import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { WithUserProfileConsumer } from '../mixins/with-user-profile-consumer';
import { styles as sharedStyles } from '../styles/shared-styles';
import '../components/under-construction.js';
@customElement('order-page')
export class OrderPage extends WithUserProfileConsumer(LitElement) {
  static styles = [
    sharedStyles,
    css`
      /* Add styles here */
    `,
  ];

  render() {
    return html` <under-construction></under-construction> `;
  }
}
